import { truncateString } from 'utils/general';

import { IHome } from '@/modules/home/types';
import { CircularBgImage } from '@/shared/components/atoms';
import ProgressBar from '@/shared/components/atoms/ProgressBar';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Cube from '~/images/shared/Cube.svg';
import LightLocation from '~/images/shared/LightLocation.svg';

const WorkforceDistributionRow: React.FC<
  IHome.IWorkforceDistributionRowProps
> = ({ item, totalCount, type }) => {
  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <div className='flex items-center gap-2'>
      <div className='flex items-center gap-2'>
        {selectedAsset?.entityTypeId === 2 ? (
          <CircularBgImage
            size='sm'
            imageSrc={item.image ?? ''}
            bgColor='bg-outline-default'
            imageClassName='scale-125'
          />
        ) : type === 'operations' ? (
          <Cube />
        ) : (
          <LightLocation />
        )}

        <div className='w-82 text-surface-10' title={item.name}>
          {truncateString({
            text: item.name,
            length: 10,
          })}
        </div>
      </div>
      <ProgressBar
        value={item.workersCount}
        max={totalCount}
        barBgColor='bg-primary-60'
        barClassName='text-white'
      />
    </div>
  );
};

export { WorkforceDistributionRow };
